import { createFileRoute } from "@tanstack/react-router";

import { ExpensesPage } from "../../../features/accounting/expenses-page";

export const Route = createFileRoute("/_app/accounting/expenses")({ component: ExpensesPage });
